import {HOST, TITLE, registerModel} from '@/utils/base';

export default [
    // 共通 - 主页
    {
        path: HOST,
        component: () => import('@/routes/common/index'),
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    // 共通 - 登录
    {
        name: 'login',
        path: HOST + 'login',
        component: () => import('@/routes/common/login'),
        beforeEnter: (to, from, next) => {
            document.title = TITLE;
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
    },

    // 系统首页
    {
        path: HOST + 'home',
        component: () => import('@/routes/common/home'),
        beforeEnter: (to, from, next) => {
            // document.title = '联扩供应链系统'
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
    },
    // 系统设置
    {
        path: HOST + 'system',
        component: () => import('@/layouts/ImsLayout'),
        beforeEnter: (to, from, next) => {
            // document.title = '联扩供应链系统'
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
        children: [
            {
                // 新增审批流
                path: 'approval/add',
                component: () => import('@/routes/system/approval/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 审批流编辑
                path: 'approval/edit',
                component: () => import('@/routes/system/approval/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                //  审批流列表
                path: 'approval/list',
                component: () => import('@/routes/system/approval/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 业务审批配置
                path: 'approval/tradetype_list',
                component: () => import('@/routes/system/approval/tradetype_list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 审批申请列表
                path: 'approval/approval_list/:id',
                component: () => import('@/routes/approval/approval_list'),
                beforeEnter: (to, from, next) => {
                    document.title = '联扩供应链系统';
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 申请列表
                path: 'approval/apply_list',
                component: () => import('@/routes/approval/apply_list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 组织结构设置 - 部门管理(树形结构)
                path: 'organization/department',
                component: () => import('@/routes/system/organization/department_tree'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },

            {
                // 组织结构设置 - 职员管理
                path: 'organization/user',
                component: () => import('@/routes/system/organization/user_list'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 组织结构设置 - 岗位管理
                path: 'organization/position',
                component: () => import('@/routes/system/organization/position_list'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 公司信息设置
                path: 'companies',
                component: () => import('@/routes/system/companies/index'),
            },
            {
                // 公司信息设置 - 添加
                path: 'companies/add',
                component: () => import('@/routes/system/companies/add'),
            },
            {
                // 公司信息设置 - 编辑
                path: 'companies/edit',
                component: () => import('@/routes/system/companies/edit'),
            },
            {
                // 权限配置管理
                path: 'permission',
                component: () => import('@/routes/system/permission/index'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 定时任务管理
                path: 'job/list',
                component: () => import('@/routes/system/job/list'),
            },
            {
                // 定时任务 - 调度日志
                path: 'job/log_list',
                component: () => import('@/routes/system/job/log_list'),
            },
        ],
    },
    // 基础数据
    {
        path: HOST + 'database',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 产品分类
                path: 'product/list',
                component: () => import('@/routes/database/product/list'),
            },
            {
                // 材料管理
                path: 'materia/list',
                component: () => import('@/routes/database/materia/list'),
            },
            {
                // 规格管理
                path: 'specifications/list',
                component: () => import('@/routes/database/specifications/list'),
            },
            {
                //生产厂家管理
                path: 'manufacturer/list',
                component: () => import('@/routes/database/manufacturer/list'),
            },
            {
                //选项数据管理
                path: 'options/list',
                component: () => import('@/routes/database/options/list'),
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/frame_router.js